module.exports = __webpack_public_path__ + "static/media/beefyfinance.bec288df.png";